"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _user = require("@/api/base/user");
var _auth = require("@/utils/auth");
var _app = require("@/utils/app");
var _router = require("@/router");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _store = _interopRequireDefault(require("@/store"));
var state = {
  token: (0, _auth.getToken)(),
  id: (0, _auth.getUid)(),
  username: (0, _auth.getUserName)(),
  mobile: '',
  avatar: '',
  role: 0,
  app_roles: [],
  roles: {},
  ticket: (0, _auth.getTicket)(),
  menu: ''
};
var mutations = {
  SET_USER_INFO: function SET_USER_INFO(state) {
    var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    state.username = userInfo.name || state.username || userInfo.name;
    state.mobile = userInfo.mobile || state.mobile;
    state.avatar = userInfo.avatar || state.avatar;
    // 用户权限
    state.role = userInfo.type || state.role;
    state.roles = userInfo.roles || state.roles;
    // 用户APP权限
    state.app_roles = userInfo.app_roles || state.app_roles;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_ROLE: function SET_ROLE(state, role) {
    state.role = role;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_APP_ROLES: function SET_APP_ROLES(state, app_roles) {
    state.app_roles = app_roles;
  },
  SET_ID: function SET_ID(state, id) {
    state.id = id;
  },
  SET_TICKET: function SET_TICKET(state, ticket) {
    state.ticket = ticket;
  },
  SET_MENU: function SET_MENU(state, menu) {
    state.menu = menu;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var params = {
      name: userInfo.mobile,
      password: (0, _jsMd.default)(userInfo.password)
    };
    var paramsSortKeys = Object.keys(params).sort();
    var concatStr = paramsSortKeys.map(function (key) {
      var value = encodeURIComponent(params[key]);
      return "".concat(key, "=").concat(value, "&");
    }).join('');
    var sign = (0, _jsMd.default)(concatStr);
    params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
      sign: sign
    });
    return new Promise(function (resolve, reject) {
      (0, _user.login)(params).then(function (res) {
        var data = res.data;
        commit('SET_TICKET', data.ticket);
        (0, _auth.setTicket)(data.ticket);
        (0, _app.removeCurPid)();
        var ticketParams = {
          app_id: userInfo.app_id,
          ticket: data.ticket
        };
        var ticketParamsSortKeys = Object.keys(ticketParams).sort();
        var ticketConcatStr = ticketParamsSortKeys.map(function (key) {
          var value = encodeURIComponent(ticketParams[key]);
          return "".concat(key, "=").concat(value, "&");
        }).join('');
        var ticketSign = (0, _jsMd.default)(ticketConcatStr);
        ticketParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, ticketParams), {}, {
          sign: ticketSign
        });
        return (0, _user.ticketLoginRequest)(ticketParams);
      }).then(function (res) {
        var data = res.data;
        data.token = 'Bearer ' + data.access_token;
        commit('SET_ID', data.user.id);
        commit('SET_USER_INFO', data.user);
        commit('SET_TOKEN', data.token);
        commit('SET_ROLES', data.user.roles);
        commit('SET_MENU', data.menu.children);
        (0, _auth.setToken)(data.token);
        (0, _auth.setUid)(data.user.id);
        (0, _auth.setUserName)(data.user.name);
        console.log('ticketLoginRequest success');
        resolve();
      }).catch(function (error) {
        console.log('ticketLoginRequest failed', error);
        reject(error);
      });
    });
  },
  fsLogin: function fsLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    var params = {
      code: userInfo.code,
      tm: userInfo.tm
    };
    var paramsSortKeys = Object.keys(params).sort();
    var concatStr = paramsSortKeys.map(function (key) {
      var value = encodeURIComponent(params[key]);
      return "".concat(key, "=").concat(value, "&");
    }).join('');
    var sign = (0, _jsMd.default)(concatStr);
    params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
      sign: sign
    });
    return new Promise(function (resolve, reject) {
      (0, _user.codeLogin)(params).then(function (res) {
        var data = res.data;
        commit('SET_TICKET', data.ticket);
        (0, _auth.setTicket)(data.ticket);
        (0, _app.removeCurPid)();
        var ticketParams = {
          app_id: userInfo.app_id,
          ticket: data.ticket
        };
        var ticketParamsSortKeys = Object.keys(ticketParams).sort();
        var ticketConcatStr = ticketParamsSortKeys.map(function (key) {
          var value = encodeURIComponent(ticketParams[key]);
          return "".concat(key, "=").concat(value, "&");
        }).join('');
        var ticketSign = (0, _jsMd.default)(ticketConcatStr);
        ticketParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, ticketParams), {}, {
          sign: ticketSign
        });
        return (0, _user.ticketLoginRequest)(ticketParams);
      }).then(function (res) {
        var data = res.data;
        data.token = 'Bearer ' + data.access_token;
        commit('SET_ID', data.user.id);
        commit('SET_USER_INFO', data.user);
        commit('SET_TOKEN', data.token);
        commit('SET_ROLES', data.user.roles);
        commit('SET_MENU', data.menu.children);
        (0, _auth.setToken)(data.token);
        (0, _auth.setUid)(data.user.id);
        (0, _auth.setUserName)(data.user.name);
        resolve();
      }).catch(function (error) {
        (0, _auth.removeCode)();
        console.log('ticketLoginRequest failed', error);
        reject(error);
      });
    });
  },
  ticketLogin: function ticketLogin(_ref3) {
    var commit = _ref3.commit;
    var ticketParams = {
      ticket: state.ticket,
      app_id: '1'
    };
    var ticketParamsSortKeys = Object.keys(ticketParams).sort();
    var ticketConcatStr = ticketParamsSortKeys.map(function (key) {
      var value = encodeURIComponent(ticketParams[key]);
      return "".concat(key, "=").concat(value, "&");
    }).join('');
    var ticketSign = (0, _jsMd.default)(ticketConcatStr);
    ticketParams = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, ticketParams), {}, {
      sign: ticketSign
    });
    return new Promise(function (resolve, reject) {
      (0, _user.ticketLoginRequest)(ticketParams).then(function (res) {
        var data = res.data;
        data.token = 'Bearer ' + data.access_token;
        commit('SET_ID', data.user.id);
        commit('SET_USER_INFO', data.user);
        commit('SET_TOKEN', data.token);
        commit('SET_MENU', data.menu.children);
        (0, _auth.setToken)(data.token);
        (0, _auth.setUserName)(data.user.name);
        (0, _auth.setUid)(data.user.id);
        console.log('ticketLoginRequest success');
        resolve();
      }).catch(function (error) {
        alert('登录过期，请重新登录');
        console.log('ticket失效，获取token失败', error);
        _store.default.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    });
  },
  register: function register(_ref4, userInfo) {
    var commit = _ref4.commit;
    var mobile = userInfo.mobile,
      code = userInfo.code,
      password = userInfo.password,
      password_confirmation = userInfo.password_confirmation;
    return new Promise(function (resolve, reject) {
      (0, _user.register)({
        mobile: mobile.trim(),
        code: code,
        password: password,
        password_confirmation: password_confirmation
      }).then(function (res) {
        var data = res.data;
        data.token = 'Bearer ' + data.token;
        commit('SET_USER_INFO', data.user);
        commit('SET_TOKEN', data.token);
        commit('SET_ROLES', data.user.roles);
        (0, _auth.setToken)(data.token);
        (0, _auth.setUid)(data.user.id);
        (0, _app.removeCurPid)();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLE', 0);
      commit('SET_APP_ROLES', []);
      commit('SET_ROLES', {});
      (0, _auth.removeToken)();
      (0, _auth.removeTicket)();
      (0, _app.removeCurPid)();
      (0, _auth.removeUserName)();
      resolve();
    });
  },
  getUserInfo: function getUserInfo(_ref6, id) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.getUserInfo)(id).then(function (response) {
        var data = response.data;
        if (!data) {
          console.log('Verification failed, please Login again.');
          reject('Verification failed, please Login again.');
        }

        // const { roles } = data

        // // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        //   console.log('getInfo: roles must be a non-null array!')
        //   reject('getInfo: roles must be a non-null array!')
        // }

        commit('SET_USER_INFO', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state,
      dispatch = _ref7.dispatch;
    return new Promise(function (resolve, reject) {
      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      (0, _user.logout)().then(function (res) {
        console.log('logout res:', res);
        commit('SET_TOKEN', '');
        commit('SET_TICKET', '');
        commit('SET_ROLE', 0);
        commit('SET_APP_ROLES', []);
        commit('SET_ROLES', {});
        (0, _auth.removeCode)();
        (0, _auth.removeTicket)();
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();
        (0, _app.removeCurPid)();
        resolve(res);
      });
    });
  },
  // 更新用户信息
  updateUserInfo: function updateUserInfo(_ref8, _ref9) {
    var state = _ref8.state,
      commit = _ref8.commit;
    var username = _ref9.username,
      avatar = _ref9.avatar;
    return new Promise(function (resolve, reject) {
      (0, _user.updateUserInfo)({
        username: username,
        avatar: avatar
      }).then(function (res) {
        commit('SET_USER_INFO', {
          username: username,
          avatar: avatar
        });
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;